import { render } from "./SingleProject.vue?vue&type=template&id=625a3010"
import script from "./SingleProject.vue?vue&type=script&lang=js"
export * from "./SingleProject.vue?vue&type=script&lang=js"
script.render = render

export default script